module.exports = __webpack_public_path__ + "static/img/reportH5.96db4cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reportH5.png
// module id = YaA+
// module chunks = 1